import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-700/30">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-vip-crown-2-fill text-background-950 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50">金沙娱乐</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              金沙娱乐官方平台，为您提供顶级在线娱乐体验。丰富的游戏种类、安全可靠的支付环境、24小时专属客服，让您尽享娱乐盛宴。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-200">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-200">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800/50 text-foreground-400 hover:text-primary-400 hover:bg-primary-500/10 transition-all duration-200">
                <i className="ri-telegram-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">游戏分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-150 flex items-center gap-2"
                  >
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${cat.icon} text-xs`}></i>
                    </div>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-150">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-150">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/youhui-huodong" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-150">
                  优惠活动
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-150">
                  用户协议
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-150">
                  隐私政策
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors duration-150">
                  帮助中心
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-50 mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-customer-service-line text-foreground-400 text-sm"></i>
                </div>
                <span className="text-sm text-foreground-500">7×24小时在线客服</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-mail-line text-foreground-400 text-sm"></i>
                </div>
                <span className="text-sm text-foreground-500">service@jinshaentertainment.com</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-phone-line text-foreground-400 text-sm"></i>
                </div>
                <span className="text-sm text-foreground-500">VIP专线：400-888-9999</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700/20">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            © 2024 金沙娱乐官方平台 版权所有
          </p>
          <p className="text-xs text-foreground-600 text-center">
            金沙娱乐提醒您：适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。
          </p>
          <p className="text-xs text-foreground-600">
            18岁以上方可参与 | 理性娱乐
          </p>
        </div>
      </div>
    </footer>
  );
}